t = require('app/scripts/views/internal/teacup-with-helpers')('checklist_item')

module.exports = ->
  t.div { class: 'checklist-item-checkbox ' + t.mustacheBlock('__ed', (-> 'enabled js-toggle-checklist-item')) }, ->
    t.icon 'check', { class: 'checklist-item-checkbox-check' }

  t.div { class: 'checklist-item-details non-empty js-checkitem ' + t.mustacheBlock('__ed', (-> 'editable')), attr: 'name' }, ->
    t.div '.checklist-item-row.js-checkitem-row.current.hide-on-edit', ->
      t.span '.checklist-item-details-text.markeddown.js-checkitem-name'

      t.mustacheBlock '__ed', ->
        t.p '.edits-warning.quiet', ->
          t.format 'you-have-unsaved-edits-on-this-field'
          t.text ' '
          t.a '.js-view-edits', { href: '#' }, ->
            t.format 'view-edits'
          t.text " - "
          t.a '.js-discard-edits', { href: '#' }, ->
            t.format 'discard'

    t.mustacheBlock '__ed', ->
      t.div '.checklist-item-menu-wrapper.hide-on-edit', ->
        t.div '.checklist-item-menu.js-open-menu', ->
          t.span '.icon-sm.icon-overflow-menu-horizontal'

      t.div '.edit.options-menu', ->
        t.textarea '.field.full.single-line.js-checkitem-input', { type: 'text' }
